import Box, { BoxProps } from '@mui/material/Box'
import React from 'react'
import Carousel from 'react-material-ui-carousel'

import Banner, { iBannerProps } from './Banner'

const BannerListCarrousel: React.FC<{ banners: iBannerProps[]; WrapperProps: BoxProps }> = ({
  WrapperProps,
  banners
}) => {
  const { height, width, left, ...restProps } = WrapperProps

  return (
    <Carousel
      sx={{ width: width as string, left: left as string }}
      indicators={banners.length > 1}
      navButtonsAlwaysInvisible
      animation="slide"
      height={height as number}
      indicatorContainerProps={{
        style: {
          height: '34px'
        }
      }}
    >
      {banners.map(item => (
        <Box key={item.id} height={`calc(${height}px)`} width={width} {...restProps}>
          <Banner {...item} id={item.id} />
        </Box>
      ))}
    </Carousel>
  )
}

export default BannerListCarrousel
